import { connect } from 'react-redux';

import {
  GET_LIST_ROOM_OF_PLACE,
  GET_PLACE_DETAIL,
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY,
} from 'store/place/actionTypes';

import EditChildExtraBedPolicy from './EditChildExtraBedPolicy';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingUpdateChildrenAndExtraBedPolicy: state.Place.isLoadingUpdateChildrenAndExtraBedPolicy,

  roomOfPlaceList: state.Place.roomOfPlaceList,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionGetListRoomsOfPlace: (payload) => dispatch({
    type: GET_LIST_ROOM_OF_PLACE,
    payload,
  }),

  actionUpdateChildrenAndExtraBedPolicy: (payload) => dispatch({
    type: UPDATE_CHILDREN_AND_EXTRA_BED_POLICY,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditChildExtraBedPolicy);
